import script from "./LanguageToggle.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguageToggle.vue?vue&type=script&setup=true&lang=js"

import "./LanguageToggle.vue?vue&type=style&index=0&id=7cc93152&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cc93152"]])

export default __exports__